<template>
    <div class="loader-container">
        <div class="loader"></div>
    </div>
</template>

<style>
.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.loader {
    border: 4px solid rgba(0, 0, 0, 0.1);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            redirects: {
                // public redirect : internal path name
                "company-info-service-cn": "company-info-service-cn",
                "comply-advantage": "comply-advantage",
                "find-partner-info-advanced": "find-partner-info-advanced",
                "find-partner-info": "find-partner-info",
                "business-note": "business-note",
                "short-search": "short-search",
                "person-search-service": "person-search-service",
                "risk-control-service": "risk-control-service",
            },
            redirect: "",
        }
    },

    mounted() {
            console.log(window);
            console.log('called token updated');
            const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
            const ssoParam = urlParams.get('sso');
            const redirect = urlParams.get('redirect');
            console.log('sso param');
            console.log(ssoParam);
            if (ssoParam) {
                this.sendSSOToBackend(ssoParam, redirect);
            }
    },

    methods: {
        logout() {
            axios
                .get(window.base + "/account/logout")
                .then(() => {
                    this.refreshToken();
                })
                .catch(() => {
                    this.logout();
                });
        },
        refreshToken() {
            console.log('refresh token1');
            axios
                .get(window.base + "/account/RefreshToken")
                .then((response) => {
                    const regex =
                        /name="__RequestVerificationToken" type="hidden" value="(.*)"/gm;
                    let m;
                    m = regex.exec(response.data);
                    window.token = m[1];
                    window.axios.defaults.headers.common["__RequestVerificationToken"] =
                        window.token;
                    console.log("🔒 Token updated");
                    window.vue.$emit("token_updated_sso");
                    window.is_token_loaded.status = false;
                })
                .catch(() => {

                    console.log('catch refresh token');
                    this.refreshToken();
                    this.$router.push('/sign-in');
                });
        },
        sendSSOToBackend(ssoValue, redirect) {
            try {
                axios.post(window.base + '/account/SSOLogin', null, {
                    headers: {
                        Authorization: `Bearer ${ssoValue}`
                    }
                }).then((response) => {
                    console.log('sso response', response);
                    if (response.data.statusCode == 200) {
                        let user_object = response.data.user;
                        user_object.Roles = JSON.parse(user_object.Roles);
                        this.$store.commit("login", {
                            user: user_object /*JSON.parse(*/ /*.replace('"user": ', ''))*/,
                        });
                        if (redirect && Object.keys(this.redirects).includes(redirect)) {
                            this.$router.push({ name: this.redirects[redirect] });
                            redirect = "";
                        } else {
                            this.$router.push({ name: "home-after-login" });
                        }
                        this.login_disabled = true;
                        window.updateToken();
                        // window.location.reload()
                        new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.login-successfull"),
                            timeout: 5000,
                        }).show();
                        axios
                            .get(window.base + "/document/getfirmfull")
                            .then((response) => {
                                this.$store.commit("load_firm", response.data);
                            });
                    }
                    else {
                        //window.updateToken();
                        axios.get(window.base + "/account/logout");
                        var errorMessage = this.translate(response.data.statusMessage);

                        new Noty({
                            theme: "light",
                            type: "error",
                            text: errorMessage,
                            timeout: 5000,
                        }).show();
                    }
                }, (error) => {
                    console.error('Error sending SSO to backend:', error);
                    this.$router.push('/sign-in');
                    new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t("message.message.login-unsuccessfull"),
                        timeout: 5000,
                    }).show();
                });
            } catch (error) {
                console.error('Error sending SSO to backend:', error);
                this.$router.push('/sign-in');
                new Noty({
                    theme: "light",
                    type: "error",
                    text: this.$t("message.message.login-unsuccessfull"),
                    timeout: 5000,
                }).show();
            }
        }
    }
}
</script>
  